import type { ReactElement } from "react";

type AppFontsStyleProps = {
	interFontFamily: string;
	poppinsFontFamily: string;
};

export function AppFontsStyle({ interFontFamily, poppinsFontFamily }: AppFontsStyleProps): ReactElement {
	return (
		<style jsx global>{`
			:root {
				--font-inter: ${interFontFamily};
				--font-poppins: ${poppinsFontFamily};
			}
		`}</style>
	);
}
